import Layout from '../views/layout/layout'

export default {
    path: '/opration',
    component: Layout,
    children: [
        {
            path: '/busiOprationTag/home',
            name: 'busiOprationTag',
            component: () => import('../views/opration/tag/index'),
            meta: {title: '标签管理', keepAlive: true}
        },
        {
            path: '/opration/projectReport',
            name: 'projectReportForm',
            component: () => import('../views/opration/projectReport/index'),
            meta: {title: '项目汇报模板', keepAlive: true}
        },
        {
            path: '/opration/messageTemplate',
            name: 'messageTemplatelList',
            component: () => import('../views/opration/messageTemplate/index'),
            meta: {title: '消息模板管理', keepAlive: true}
        },
        {
            path: '/opration/customerMessage',
            name: 'customerMessagelList',
            component: () => import('../views/opration/customerMessage/index'),
            meta: {title: '用户消息管理', keepAlive: true}
        },
        {
            path: '/opration/house',
            name: 'houseDetailList',
            component: () => import('../views/opration/house/index'),
            meta: {title: '楼盘基本信息', keepAlive: true}
        },
        {
            path: '/opration/home',
            name: 'homeList',
            component: () => import('../views/opration/house/home_list'),
            meta: {title: '房屋管理', keepAlive: true}
        },
        {
            path: '/opration/home_add',
            name: 'homeAdd',
            component: () => import('../views/opration/house/home_add'),
            meta: {title: '房屋编辑'}
        },
        {
            path: '/opration/home_detail',
            name: 'homeDetail',
            component: () => import('../views/opration/house/home_details'),
            meta: {title: '房屋详情'}
        },
        {
            path: '/opration/house_add',
            name: 'houseFrontAdd',
            component: () => import('../views/opration/house/house_add'),
            meta: {title: '楼盘新增'}
        },
        {
            path: '/opration/house_edit',
            name: 'houseEdit',
            component: () => import('../views/opration/house/house_add'),
            meta: {title: '楼盘修改'}
        },
        {
            path: '/opration/house_name_details',
            name: 'houseDetails',
            component: () => import('../views/opration/house/house_name_details'),
            meta: {title: '楼盘详情'}
        },
        {
            path: '/opration/questionProject',
            name: 'questionProject',
            component: () => import('../views/opration/question/project/index'),
            meta: {title: '问卷管理'}
        },
        {
            path: '/satisfaction/survey',
            name: 'satisfactionSurvey',
            component: () => import('../views/opration/question/atjiaQuestionnaire/index'),
            meta: {title: '满意度调查'}
        },
        {
            path: '/satisfaction/list',
            name: 'satisfactionList',
            component: () => import('../views/opration/question/atjiaQuestionnaireList/index'),
            meta: {title: '问卷推送列表'}
        },
        {
            path: '/opration/question',
            name: 'questionOpration',
            component: () => import('../views/opration/question/index'),
            meta: {title: '精细报价问卷管理'}
        },
        {
            path: '/opration/topic',
            name: 'oprationTopic',
            component: () => import('../views/opration/question/topic'),
            meta: {title: '问卷题目管理'}
        },
        {
            path: '/opration/answer',
            name: 'oprationAnswer',
            component: () => import('../views/opration/answer/index'),
            meta: {title: '问题答案记录', keepAlive: true}
        },
        {
            path: '/opration/answerDetail',
            name: 'oprationAnswerDetail',
            component: () => import('../views/opration/answer/answerDetail'),
            meta: {title: '答案选项'}
        },
        {
            path: '/opration/promotion/index',
            name: 'promotion',
            component: () => import('../views/opration/promotion/index'),
            meta: {title: '活动推广', keepAlive: true}
        },
        {
            path: '/channelFee/index',
            name: 'channelFee',
            component: () => import('../views/opration/channelFee/index'),
            meta: {title: '渠道费用维护', keepAlive: true}
        }
    ]
}
